<template>
<div></div>
</template>
<script>
import { getTopicByNames } from '@/api/collection'
export default {
    name: 'collectionTopic',
    props: ['topicNames'],
    data () {
        return {
            list: []
        }
    },
    created () {
        this.fetchData()
    },
    methods: {
        fetchData () {
            getTopicByNames(this.topicNames).then(response => {
                this.list = response
            })
        }
    }
}
</script>
